<template>
    <v-container grid-list-xs fluid>
        <v-simple-table>
            <template v-slot:default>
                <thead>
                    <tr>
                        <th class="text-left">Product</th>
                        <th class="text-left">Order QTY</th>
                        <th>Dispatched QTY</th>
                        <th>OrderID#</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, j) in data" :key="j">
                        <td>
                            {{ item.Product }}
                        </td>
                        <td>
                            {{ item.Quantity }}
                        </td>
                        <td>
                            {{ item.DispatchedQuantity }}
                        </td>
                        <td>
                            {{ item.OrderID }}
                        </td>
                    </tr>
                </tbody>
            </template>
        </v-simple-table>
    </v-container>
</template>
<script>
import axios from "axios";
export default {
    props: ['prm'],
    data: function() {
        return {
            data: []
        };
    },
    mounted() {
        
       this.loadOrderDetails(this.prm.OrderID);
    },
    methods: {
        loadOrderDetails: function(orderID) { 
            
            var str = this.$store;
            axios
                    .get('order-detail/order/'+orderID, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(response => {
                        console.log(response.data.data);
                        this.data = response.data.data;
                    })
                    .catch(function(error) {
                        console.log(error);
                        if (error.response.status === 403) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text:
                                    'You do not have the permission to use this function.'
                            });
                        }
                        if (error.response.status === 500) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text: 'An error has ocurred, please try again.'
                            });
                        }
                    });
        },

    }
};
</script>
